// Login tokens (JWTs from /api/login) expire after 2 hours, but the logged-in
// user used to live in localStorage forever: once the token expired, every
// request failed with 401 (the console errors) while the page still looked
// logged in. These read the token's own `exp` so the app can log out cleanly
// at expiry instead.

// Milliseconds since epoch, or null when the token carries no readable expiry.
export function tokenExpiresAt(token) {
    try {
        const part = String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = part + '='.repeat((4 - (part.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));
        return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
    } catch (_) {
        return null;
    }
}

// A missing token counts as expired; an unreadable expiry does not (the server
// still has the final say and answers 401 if it disagrees).
export function isTokenExpired(token, now = Date.now()) {
    if (!token) return true;
    const exp = tokenExpiresAt(token);
    return exp != null && exp <= now;
}
